import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { EmptyText } from "@/components/EmptyText";
import { Header } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { DetailSection } from "@/components/Section";
import { Text } from "@/components/Text";
import { Flex, Section, Tooltip } from "@/eworkitComponents";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";

import { ConsultantProfileAboutMeEdit } from "./AboutMeForm";

interface Props extends IConsultantProfileSectionProps, IEditableSectionRenderProps {}

export const AboutMeSection: FunctionComponent<Props> = ({ editableProps, onUpdate, record }) => {
  const { t } = useTranslation("session");

  return (
    <Section grow={1} direction="column" innerMargin="md" testName="languages">
      <Flex direction="row">
        <Flex grow={1} direction="row" innerMargin="sm">
          <Header size="sm" color="black" weight="bold">
            {t("CONSULTANT_PROFILES.DETAIL.ABOUT_ME.SECTION_HEADER")}
          </Header>
          {editableProps.editable && (
            <Tooltip content={t("CONSULTANT_PROFILES.DETAIL.ABOUT_ME.HEADER_TOOLTIP")} placement="top">
              <Icon icon="info" color="grey3" size="lg" />
            </Tooltip>
          )}
        </Flex>
        {!editableProps.editable && (
          <Tooltip content={t("CONSULTANT_PROFILES.DETAIL.ABOUT_ME.MANAGER_UNABLE_TO_EDIT")} placement="top" size="md">
            <Button variant="clean">
              <Icon color="grey3" icon="info-1" size="lg" />
            </Button>
          </Tooltip>
        )}
      </Flex>
      <Flex grow={1} innerMargin="sm">
        {editableProps.editMode ? (
          <ConsultantProfileAboutMeEdit
            source={record}
            initialValues={{ aboutMe: record.aboutMe }}
            onUpdate={onUpdate}
            onCancel={editableProps.handleCancelClick}
            editableProps={editableProps}
          />
        ) : (
          <Flex direction="column" innerMargin="sm">
            <DetailSection
              label={t("CONSULTANT_PROFILES.DETAIL.ABOUT_ME.PROFESSIONAL_SUMMARY_QUESTION")}
              size="md"
              color="grey1">
              {record.aboutMe && record.aboutMe.professionalSummary ? (
                <Text wordBreak="word" text={record.aboutMe.professionalSummary} />
              ) : (
                <EmptyText />
              )}
            </DetailSection>
            <DetailSection
              label={t("CONSULTANT_PROFILES.DETAIL.ABOUT_ME.REASON_OF_BEING_PROFESSIONALIST_QUESTION")}
              size="md"
              color="grey1">
              {record.aboutMe && record.aboutMe.reasonOfBeingProfessionalist ? (
                <Text wordBreak="word" text={record.aboutMe.reasonOfBeingProfessionalist} />
              ) : (
                <EmptyText />
              )}
            </DetailSection>
            <DetailSection
              label={t("CONSULTANT_PROFILES.DETAIL.ABOUT_ME.PERFECT_COWORKERS_PROFILE_QUESTION")}
              size="md"
              color="grey1">
              {record.aboutMe && record.aboutMe.perfectCoworkersProfile ? (
                <Text wordBreak="word" text={record.aboutMe.perfectCoworkersProfile} />
              ) : (
                <EmptyText />
              )}
            </DetailSection>
          </Flex>
        )}
      </Flex>
    </Section>
  );
};
